<template>
  <hic-list-page title="文书模板" :entities="entities" :condition="condition" @load="query" :loading="searchLoading" keyword-placeholder="请输入名称或编码">
    <template slot="buttons">
      <el-button v-if="permission.emr_tmpl_edit" type="primary" @click="create" size="small"> <i class="el-icon-plus"></i> 新建 </el-button>
    </template>
    <template slot="search">
      <el-checkbox v-if="permission.emr_tmpl_disable" v-model="condition.disabled" @change="query">查看停用模板</el-checkbox>
    </template>
    <el-table-column label="操作" width="150" align="center">
      <template slot-scope="{ row }">
        <!-- <el-button v-if="permission.emr_tmpl_edit && row.id && row.auditState != Enum.MrAuditState.审批中" type="primary" icon="el-icon-edit" size="mini" @click="editTmpl(row)" title="编辑" :disabled="row.disabled" /> -->
        <el-button v-if="row.id" type="primary" icon="el-icon-search" circle plain size="mini" @click="view(row)" title="预览" />
        <el-dropdown v-if="permission.emr_tmpl_edit && row.id && !row.disabled && row.auditState != Enum.MrAuditState.审批中" split-button type="primary" @click="editTmpl(row)" @command="cmdHandle($event, row)" :disabled="row.disabled" size="mini" class="left-pad">
          <i class="el-icon-edit" />
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="edit"><i class="el-icon-edit-outline" />基本</el-dropdown-item>
            <el-dropdown-item command="copy"><i class="el-icon-document-copy" />复制</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-button v-if="permission.emr_tmpl_audit && row.id && row.auditState == Enum.MrAuditState.审批中" type="warning" icon="el-icon-check" size="mini" @click="editTmpl(row)" title="审批">审批</el-button>
        <el-button v-if="permission.emr_tmpl_disable && row.id && row.disabled" type="danger" icon="el-icon-delete" circle plain size="mini" @click="del(row)" title="停用" />
        <el-button v-if="permission.emr_tmpl_disable && row.id && row.disabled" type="primary" icon="el-icon-refresh-left" circle plain size="mini" @click="recover(row)" title="恢复" />
      </template>
    </el-table-column>
    <el-table-column type="expand" width="20">
      <template slot-scope="{ row }">
        <el-skeleton v-if="!row.vers" animated style="width: 35rem" />
        <el-table v-else :data="row.vers" size="mini" style="width: 35rem" border>
          <el-table-column label="查看" prop="ver" width="100" align="center">
            <template slot-scope="{ row }">
              <el-button type="text" size="mini" icon="el-icon-search" @click="view(row.id)" />
              <el-popconfirm confirm-button-text="确定" cancel-button-text="取消" icon="el-icon-info" icon-color="red" title="确定删除当前版本吗？" class="left-pad" @confirm="delVer(row)">
                <el-button type="text" size="mini" icon="el-icon-delete" slot="reference" class="danger" />
              </el-popconfirm>
            </template>
          </el-table-column>
          <el-table-column label="版本" prop="ver" width="60" align="center"></el-table-column>
          <el-table-column label="状态" prop="auditState" width="80" align="center">
            <template slot-scope="{ row }">
              <el-tag v-if="row.auditState == '草稿'" size="mini" effect="plain">{{ row.auditState }}</el-tag>
              <el-tag v-if="row.auditState == '审批中'" size="mini" type="warning" effect="plain">{{ row.auditState }} </el-tag>
              <el-tag v-if="row.auditState == '通过'" size="mini" type="success" effect="plain">{{ row.auditState }} </el-tag>
              <el-tag v-if="row.auditState == '未通过'" size="mini" type="danger" effect="plain">{{ row.auditState }} </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="审批人" prop="auditorName" align="center"></el-table-column>
          <el-table-column label="审批时间" prop="auditDate" align="center">
            <template slot-scope="{ row }">
              {{ row.auditDate | fmtDate }}
            </template>
          </el-table-column>
        </el-table>
      </template>
    </el-table-column>
    <el-table-column label="名称" prop="name" min-width="200" show-overflow-tooltip sortable="custom">
      <template slot-scope="{ row }">
        <b>{{ row.name }}</b>
      </template>
    </el-table-column>
    <el-table-column label="编码" prop="code" width="120" align="left" sortable="custom"></el-table-column>
    <el-table-column label="领域" prop="scope" width="100" align="center" sortable="custom" :filters="dictEnum.MrScope" :filter-multiple="false" column-key="scope">
      <template slot-scope="{ row }">
        <el-tag v-if="row.scope == '门诊'" size="small" type="success" effect="dark">门诊</el-tag>
        <el-tag v-if="row.scope == '住院'" size="small" type="danger" effect="dark">住院</el-tag>
      </template>
    </el-table-column>
    <el-table-column label="分类" prop="category" width="100" sortable="custom" :filters="dict.MrCategory" :filter-multiple="false" column-key="category">
      <template slot-scope="{ row }">
        {{ row.category | dictText("MrCategory") }}
      </template>
    </el-table-column>
    <el-table-column label="性别" prop="gender" width="100" align="center" sortable="custom" :filters="dictEnum.MrGender" :filter-multiple="false" column-key="scope"></el-table-column>
    <el-table-column label="类型" prop="type" width="100" align="center" sortable="custom" :filters="dict.MrType" :filter-multiple="false" column-key="type">
      <template slot-scope="{ row }">
        {{ row.type | dictText("MrType") }}
      </template>
    </el-table-column>
    <el-table-column v-if="permission.emr_tmpl_all" column-key="deptCode" :filters="dict.Dept" :filter-multiple="false" sortable="" label="科室" prop="deptCode" align="center">
      <template slot-scope="{ row }"> {{ row.deptCode | dictText("Dept") }} </template>
    </el-table-column>
    <el-table-column v-else label="科室" prop="deptCode" align="center">
      <template slot-scope="{ row }"> {{ row.deptCode | dictText("Dept") }} </template>
    </el-table-column>
    <el-table-column label="排序" prop="seqNo" width="80" align="center" sortable="custom"></el-table-column>
    <el-table-column label="锁定" prop="editingUserCode" width="100">
      <template slot-scope="{ row }">
        <small v-if="row.editingUserCode" style="color: #f56c6c"><i class="el-icon-lock" /> {{ row.editingUserName }}</small>
      </template>
    </el-table-column>
    <el-table-column label="版本" prop="ver" width="80" align="right"></el-table-column>
    <BaseEditor :visible.sync="showEdit" v-model="entity" :apis="meta.apis" @saved="saved" :copy-id="copyId" />
    <Editor :visible.sync="showEditor" :tmpl="entity" :apis="meta.apis" :editing-ver="editingVer" @closed="query" />
    <Viewer :visible.sync="showViewer" :tmpl="entity" />
  </hic-list-page>
</template>

<script>
  import { mapGetters } from "sw-hic";
  import store from "@/common/store";
  export default {
    beforeRouteEnter(to, from, next) {
      // 在渲染该组件的对应路由被 confirm 前调用
      // 不！能！获取组件实例 `this`
      // 因为当守卫执行前，组件实例还没被创建
      if (!store.getters.permission.emr_tmpl_query) {
        next({
          name: "err",
          params: { err: cfg.errs.NeedPromission },
        });
      } else {
        next();
      }
    },
    beforeRouteLeave(to, from, next) {
      // 导航离开该组件的对应路由时调用
      // 可以访问组件实例 `this`
      this.showEdit = false;
      this.showEditor = false;
      this.showViewer = false;
      next();
    },
    components: {
      BaseEditor: () => import("./edit"),
      Editor: () => import("./editor"),
      Viewer: () => import("./viewer"),
    },
    data() {
      return {
        meta: {
          apis: [],
        },
        searchLoading: false,
        showEditor: false,
        showEdit: false,
        showViewer: false,
        entities: {},
        entity: {},
        condition: {
          keyword: null,
          disabled: false,
          sort: "seqNo",
          asc: true,
          pageIndexOnView: 1,
          pageSize: 20,
        },
        editIndex: null,
        editingVer: null,
        copyId: 0,
      };
    },
    computed: {
      ...mapGetters(["dict", "dictEnum", "Enum", "permission", "user"]),
    },
    created: function () {
      if (!this.permission.emr_tmpl_all) {
        this.condition.deptCode = this.user.deptCode;
      }
      this.$api.Api.query().then((res) => {
        this.meta.apis = res.items;
      });
    },
    methods: {
      async query() {
        try {
          this.searchLoading = true;
          this.entities = await this.$api.Tmpl.query(this.condition);
          if (this.entities.items && this.entities.items.length) {
            let ids = this.entities.items.map((i) => i.id);
            this.$api.TmplVer.query({ mainIds: ids, sort: "id", asc: false }).then((res) => {
              let vers = res.items;
              this.entities.items.forEach((item) => {
                this.$set(
                  item,
                  "vers",
                  vers.filter((v) => v.mainId == item.id)
                );
                if (item.vers.length) {
                  if (item.vers[0].auditState == this.Enum.MrAuditState.审批中) {
                    this.$set(item, "auditState", this.Enum.MrAuditState.审批中);
                  }
                }
              });
            });
          }
        } catch (error) {
          if (!/忽略重复请求.*/.test(error)) {
            this.$message.error(error);
          }
          console.log(error);
        } finally {
          this.searchLoading = false;
        }
      },
      create: function () {
        this.copyId = 0;
        this.entity = { gender: this.Enum.MrGender.不限 };
        this.showEdit = true;
      },
      // edit(row) {
      //   this.entity = row;
      //   this.showEdit = true;
      // },
      async editTmpl(row) {
        try {
          this.entity = await this.$api.Tmpl.lock(row.id);
          row.lockKey = this.entity.lockKey;
          if (row.vers && row.vers.length) {
            this.editingVer = row.vers[0];
          } else {
            this.editingVer = null;
          }
          this.showEditor = true;
        } catch (err) {
          this.$message.error(err);
        }
      },
      view(row) {
        this.entity = row;
        this.showViewer = true;
      },
      del(row) {
        let _this = this;
        this.$api.TmplVer.query({ mainId: row.id }).then((res) => {
          if (res?.items?.length) {
            row.vers = res.items;
            this.$message.warning("模板存在版本记录无法删除，请先删除版本记录！");
          } else {
            _this
              .$confirm("确定要删除当前模板吗？")
              .then((res) => {
                this.$api.Tmpl.del(row.id).then((res) => {
                  _this.entities.items.splice(_this.entities.items.indexOf(row), 1);
                });
              })
              .catch((err) => {});
          }
        });
      },
      recover(row) {
        let _this = this;
        _this
          .$confirm("确定要停用恢复当前模板吗？")
          .then((res) => {
            row.disabled = false;
            this.$api.Tmpl.save(row).then((res) => {
              _this.entities.items.splice(_this.entities.items.indexOf(row), 1);
            });
          })
          .catch((err) => {});
      },
      queryVers(row) {
        this.$api.TmplVer.query({ mainId: row.id }).then((res) => {
          row.vers = res.items;
          if (res.items.length) {
            if (res.items[res.items.length - 1].auditState == this.Enum.MrAuditState.审批中) {
              this.$set(row, "auditState", this.Enum.MrAuditState.审批中);
            }
          }
        });
      },
      saved() {
        this.query();
      },
      filterChanged(options) {
        Object.assign(this.condition, options);
        this.query();
      },
      sortChanged(col) {
        if (!col.order) {
          this.condition.sort = "id";
          this.condition.asc = false;
        } else {
          this.condition.sort = col.prop;
          this.condition.asc = col.order == "ascending";
        }
        this.query();
      },
      delVer(row) {
        this.$api.TmplVer.del(row.id).then((res) => {
          let item = this.entities.items.find((item) => item.id == row.mainId);
          if (item) {
            item.vers.splice(item.vers.indexOf(row), 1);
          }
        });
      },
      cmdHandle(cmd, row) {
        this.entity = this.$utils.Obj.clone(row);

        if ("edit" == cmd) {
          this.copyId = 0;
        } else if ("copy" == cmd) {
          this.copyId = row.id;
          this.entity.id = null;
          this.entity.name += "拷贝";
          this.entity.code += "Copy";
        }
        this.showEdit = true;
      },
    },
  };
</script>
